import { hotjar, hotjarWorkaround } from "@/_old/lib/hotjar";

hotjar.initialize();
hotjarWorkaround();
